<template>
   <MainLayout>
    <section class="class-detail">
      <div class="container py-2 py-md-5">
        <div class="video-model">
            <video-player :options="videoOptions" />       
        </div>      
        <div class="ads-section p01 pt-4 pc"></div>
        <div class="ads-section p02 pt-3 tb"></div>
        <div class="ads-section m02 ads-section-01 pt-3 sp"></div>
        <div class="video-back">
          <button class="btn green" @click="$router.go(-1)">Return</button>
        </div>
      </div>
    </section>
  </MainLayout>
</template>
<script>
import videojs from "video.js";
import VideoPlayer from '@/components/VideoPlayer.vue';
import MainLayout from "@/components/layout/MainLayout.vue";
// import { mapGetters } from "vuex";

export default {
   name: 'videoStreaming',
   components: {
        VideoPlayer,
        MainLayout,
    },
  data() {
    return {
      videojs,
      player: null,
      route: "",
      videoOptions: {
          autoplay: true,
          controls: true,
          sources: [
          {
              src:  process.env.VUE_APP_SERVER+"/my/"+this.$route.params.type+"/"+this.$route.params.course_class_id+"/content-gp/"+this.$route.params.group_id+"/content/"+this.$route.params.id+"/stream/.m3u8",                    
              type: "application/x-mpegurl"
          }
        ]
      },
    }
  },
  // computed: {
  //     ...mapGetters(["teacherId", "studentId", "userType"]),
  // },
  mounted() {
    /*
      ** Start
      **request header for streaming
      **
      */
      videojs.Vhs.xhr.beforeRequest = (options) => {
          if (!options.headers){
              options.headers = {}
          }
          options.headers["Authorization"] = `Bearer ${this.$store.state.user['token']}`;
      }
      /*
      ** End
    */
  },
}
</script>

<style scoped>
.btn {
  width: 15%;
  padding: 8px 0;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  background: transparent linear-gradient(-270deg, rgb(54, 182, 161) 0%, rgb(58, 175, 107) 100%);
  font-size: 16px;
  border-radius: 50px;
  color: white;
}

.video-back {
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-top: 20px; */
}
</style>

